module.exports = __webpack_public_path__ + "img/gb794.prt.a3d91bee.jpg";